import React from "react"
import Obfuscate from "react-obfuscate";

import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = () => (
    <Layout>
        <SEO title="Home" />

        <div className="hero">
            <h1 className="mainTitle">Ólafur Gauti<br />Guðmundsson</h1>
            <p className="subtitle">Entrepreneur & Product Builder</p>
        </div>

        <div className="content">
            <p>
                I am the Co-founder and CEO of <a href="https://www.medalia.is" target="_blank" rel="noopener noreferrer">Medalia</a>,
                where we are building the next generation of healthcare solutions.
            </p>
            <p>
                Previously, I was a Senior Director of Engineering at <a href="https://www.tripadvisor.com" target="_blank" rel="noopener noreferrer">Tripadvisor</a>,
                following the acquisition of <a href="https://bokun.io" target="_blank" rel="noopener noreferrer">Bókun</a>,
                a company I co-founded and served as CTO.
            </p>
            <p>
                I live in Seltjarnarnes, Iceland, and I'm passionate about building products that make a difference.
            </p>

            <div className="contact">
                <p>Reach out at <Obfuscate email="olafur@gudmundsson.online" /></p>
            </div>
        </div>

    </Layout>
)

export default IndexPage
